export function splitFormatedStringIntoTimeElements(formatedString) {
	if (formatedString == undefined || null) {
		return { 'hour': '', 'min': '', 'sec': '', 'milSec': '' };
	}
	formatedString = formatedString.replace(/s/g, '');
	var splitTime = formatedString.split(':');
	var hourString = '0';
	var minString = '0';
	var secondString = '0';
	var miliSecondString = '0';
	if (splitTime.length == 3) {
		hourString = splitTime[0];
		minString = splitTime[1];
	} else if (splitTime.length == 2) {
		minString = splitTime[0];
	}

	if (splitTime[splitTime.length - 1].indexOf('.') != -1) {
		var secondsAndMillSec = splitTime[splitTime.length - 1].split('.');
		splitTime[splitTime.length - 1] = secondsAndMillSec[0];
		splitTime.push(secondsAndMillSec[1]);
		secondString = secondsAndMillSec[0] == '' ? '0' : secondsAndMillSec[0];
		miliSecondString = secondsAndMillSec[1];
	} else {
		secondString = splitTime[splitTime.length - 1];
	}
	return { 'hour': hourString, 'min': minString, 'sec': secondString, 'milSec': miliSecondString };
}

export function convertFormattedStringIntoSeconds(formatedString) {
	if (formatedString.replace(/\s/g, '') == '') {
		return 0;
	}
	if (formatedString == undefined || formatedString == null) {
		return 0;
	}
	var timeElements = splitFormatedStringIntoTimeElements(formatedString);

	// Calculate milliseconds more precisely
	var miliSecFormated = 0.0;
	if (timeElements.milSec.length < 2) {
		miliSecFormated = parseInt(timeElements.milSec) * 0.1;
	} else {
		miliSecFormated = parseInt(timeElements.milSec) * 0.01;
	}

	// Calculate total seconds and round to 3 decimal places to avoid floating point issues
	var seconds = parseInt(timeElements.hour) * 3600 + parseInt(timeElements.min) * 60 + parseInt(timeElements.sec) + miliSecFormated;

	// Round to 3 decimal places to handle floating point precision
	return parseFloat(seconds.toFixed(3));
}
export function toSeconds(string) {
	string = String(string);
	return convertFormattedStringIntoSeconds(string);
}
